import { render, staticRenderFns } from "./CuentasForm.vue?vue&type=template&id=375f0f63&"
import script from "./CuentasForm.vue?vue&type=script&lang=js&"
export * from "./CuentasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports